import React from 'react';
interface ImpressumProps {
  onBack: () => void;
}
export const Impressum: React.FC<ImpressumProps> = ({
  onBack
}) => {
  return <div className="bg-white p-4 sm:p-6 rounded-lg max-w-3xl mx-auto my-4" data-id="element-56">
      <button onClick={onBack} className="mb-4 text-blue-600 hover:underline flex items-center" data-id="element-57">
        ← Zurück
      </button>
      <h1 className="text-2xl font-bold mb-4" data-id="element-58">Impressum</h1>
      <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-59">Angaben gemäß § 5 TMG</h2>
      <p data-id="element-60">
        INTIGOO! GmbH
        <br data-id="element-61" />
        Werner-von-Siemens-Straße 33
        <br data-id="element-62" />
        49124 Georgsmarienhütte
      </p>
      <p className="mt-2" data-id="element-63">
        Handelsregister: HRB 217224
        <br data-id="element-64" />
        Registergericht: Amtsgericht Osnabrück
      </p>
      <p className="mt-2" data-id="element-65">
        Vertreten durch:
        <br data-id="element-66" />
        Fabian Kleine Huxel
        <br data-id="element-67" />
        Felix Höfelmeyer
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-68">Kontakt</h2>
      <p data-id="element-69">
        Telefon: +49 5401 1689580
        <br data-id="element-70" />
        E‑Mail: info@intigoo.de
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-71">Umsatzsteuer-ID</h2>
      <p data-id="element-72">
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        <br data-id="element-73" />
        DE 349819653
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-74">EU-Streitschlichtung</h2>
      <p data-id="element-75">
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{' '}
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-76">
          https://ec.europa.eu/consumers/odr/
        </a>
        . Unsere E‑Mail-Adresse finden Sie oben im Impressum.
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-77">
        Verbraucherstreitbeilegung / Universalschlichtungsstelle
      </h2>
      <p data-id="element-78">
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>;
};